<template>
  <div class="room-box">
    <div style="padding: 0px 12px 0px 0px" class="row">
      <div>
        <img
          v-if="Object.keys(hotelInfo).length && hotelImage.length > 0"
          id="hotel-image"
          width="140"
          height="120"
          :src="hotelImage[0].url"
        />
        <img v-else id="hotel-image" width="140" height="120" />
        <HotelStars style="text-align: center" />
      </div>
      <div id="hotel-detail">
        <span id="hotel-title" class="row">{{
          selectedRoom[0].hotelName
        }}</span>
        <span
          v-for="(room, index) in filteredRooms"
          :key="index"
          class="room-count row"
          ><i class="icon-ok-3"></i>{{ room.name }} × {{ room.count }}</span
        >
        <span class="row"><i class="icon-ok-3"></i>{{ $t("SearchResults.Refundable") }}</span>
        <span class="row"><i class="icon-ok-3"></i>{{ $t("SearchResults.InhabitancyWithBreakfast") }}</span>
      </div>
    </div>
   {{ $t("HomeBody.HotelDariushDescription") }}
    <hr />
    <template v-for="(property, index) in propertyAmenities">
      <span> {{ property }}</span>
      <span v-if="index != Object.keys(propertyAmenities).length - 1"> -</span>
    </template>
  </div>
</template>

<script>
import HotelStars from "../tour/HotelStars";

export default {
  name: "pdk-Selected-Room",
  props: {
    selectedRoom: Array,
    hotelDetail: { type: Object, default: () => ({}) },
  },
  components: { HotelStars },
  data() {
    return {
      hotelImage: [],
      propertyAmenities: [],
    };
  },
  computed: {
    filteredRooms() {
      return this.roomCount(this.selectedRoom);
    },
    hotelInfo() {
      return (this.hotelDetail = this.hotelDetail);
    },
  },
  methods: {
    roomCount(array) {
      let counts = array.reduce(
        (out, { name }) => ({ ...out, [name]: out[name] + 1 || 1 }),
        {}
      );
      return Object.keys(counts).map((key) => ({
        name: key,
        count: counts[key],
      }));
    },
  },
  created() {
    if (Object.keys(this.hotelDetail).length) {
      var hotelImageUrl = this.hotelDetail.imageURL;
      this.hotelDetail.hotelImages.forEach((img) => {
        this.hotelImage.push({
          url: hotelImageUrl + img.hotelImageID,
          caption: img.caption,
        });
      });
      this.propertyAmenities = this.hotelDetail.hotelDetail.propertyAmenities;
    }
  },
};
</script>

<style>
.room-count {
  font-size: 14px;
}
#hotel-title {
  font-size: 14px;
  color: #14012a;
  margin-bottom: 6px;
}
.room-box {
  min-height: 278px;
  padding: 20px;
  position: relative;
  background: #fff;
  margin-bottom: 30px;
  color: #333;
    -webkit-box-shadow: 0 0 15px 0 rgb(0 0 0 / 10%);
    -moz-box-shadow: 0 0 15px 0 rgba(0, 0, 0, 0.1);
    box-shadow: 0 0 15px 0 rgb(0 0 0 / 10%);
    border-radius: 15px;
    -webkit-border-radius: 15px;
    -moz-border-radius: 15;
}

#hotel-detail {
  margin-right: 25px;
}
</style>


